import { useState, useEffect } from 'react'

const getInitialTheme = () => {
  try {
    const saved = localStorage.getItem('msp-theme')
    if (saved === 'dark' || saved === 'light') return saved
  } catch {}

  try {
    if (window.matchMedia?.('(prefers-color-scheme: dark)')?.matches) return 'dark'
  } catch {}

  return 'light'
}

export function useTheme() {
  const [theme, setTheme] = useState(() => {
    return getInitialTheme()
  })

  // During SSG prerender there is no localStorage/matchMedia, so the server
  // always resolves the light theme. The client's real theme may be dark, and
  // any theme-conditional markup (e.g. the sun/moon toggle icon) would then
  // differ between server and client and throw a React #418 hydration mismatch.
  // `mounted` is false on the server AND on the client's first render, so both
  // sides render identically; components use it to defer theme-dependent UI
  // until after hydration.
  const [mounted, setMounted] = useState(false)
  useEffect(() => { setMounted(true) }, [])

  useEffect(() => {
    const root = document.documentElement
    if (theme === 'dark') {
      root.classList.add('dark')
    } else {
      root.classList.remove('dark')
    }
    try {
      localStorage.setItem('msp-theme', theme)
    } catch {}
  }, [theme])

  const toggleTheme = () => setTheme(t => t === 'dark' ? 'light' : 'dark')

  return { theme, toggleTheme, mounted }
}
